var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_767_85445)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9312 9.55232C49.8864 11.5583 47.3789 16.0717 47.3789 26.8181V54.2211C47.3789 57.3018 49.8505 58.1256 52.9312 56.1196C56.0118 54.0779 61.613 49.8726 61.613 46.8277L60.0369 19.0664C59.6071 11.4007 56.0118 7.51047 52.9312 9.55232Z",
    fill: "url(#paint0_linear_767_85445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9907 68.8216H25.9548L18.4648 28.278L18.5007 26.493C19.486 21.6365 25.1305 21.1855 28.965 21.1855H70.9907C72.5676 21.1855 73.8576 22.4559 73.8576 24.0085V65.9987C73.8576 67.5866 72.5676 68.8216 70.9907 68.8216Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7906 74.7836L25.6023 73.1357L20.6836 32.1564L20.7194 29.8281C20.7194 28.2022 21.3204 27.0746 22.2269 26.2828C23.4546 25.2103 25.3972 24.7773 28.6114 24.7773H70.3787C70.3787 24.7773 70.3787 26.0669 70.3787 27.643V67.5119L64.7906 74.7836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9655 78.403H24.4653C20.7758 78.403 18.4727 76.2564 18.4727 72.5668V26.8223C20.3843 29.6141 21.6966 30.0446 25.4578 30.0446H63.9655C65.5416 30.0446 66.8311 31.3342 66.8311 32.9103V75.5373C66.8311 77.1135 65.5416 78.403 63.9655 78.403Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3137 41.2309C30.6162 44.0052 28.9551 47.7924 28.9551 51.9675C28.9551 60.4744 35.8513 67.3706 44.3582 67.3706C52.8651 67.3706 59.7613 60.4744 59.7613 51.9675C59.7613 43.4607 52.8651 36.5645 44.3582 36.5645C41.8372 36.5645 39.4576 37.1701 37.3571 38.2439V41.2309H33.3137Z",
    fill: "url(#paint1_linear_767_85445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2227 38.7939L47.4883 39.4403V24.9921C47.4883 15.9491 50.793 9.01367 54.832 9.01367C57.7695 9.01367 60.1563 14.0384 60.1563 21.1925H59.4702C59.4702 13.9883 56.8285 10.0297 54.832 10.0297C50.7012 10.0297 48.2227 18.5776 48.2227 24.9921V38.7939Z",
    fill: "#835A00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7948 8.91016C43.2217 8.91016 42.5769 9.08926 41.9321 9.51914C38.8515 11.5609 36.3798 16.0743 36.3798 26.8207V27.6446V39.4487C30.6126 41.6748 26.5215 47.2714 26.5215 53.8237C26.5215 61.8807 32.7077 68.4929 40.5894 69.1697V94.0008H43.2622V69.1695C51.1427 68.4915 57.3276 61.8799 57.3276 53.8237C57.3276 47.2772 53.2436 41.6845 47.4844 39.4546V27.6446V26.8207C47.4844 16.0743 49.9561 11.5609 53.0366 9.55496C53.6097 9.19672 54.147 8.98179 54.6486 8.94598L43.7948 8.91016Z",
    fill: "#FFCF14"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 93.5,
    height: 93.5,
    rx: 11.75,
    stroke: "#D7D9DC",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_767_85445",
    x1: 54.496,
    y1: 9.01365,
    x2: 54.496,
    y2: 57.2131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B6000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_767_85445",
    x1: 44.3582,
    y1: 35.7522,
    x2: 55.3246,
    y2: 73.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B6000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B6000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_767_85445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64c3e84fc7dbca799317ce8803205f3b.svg";
export { ForwardRef as ReactComponent };